var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"latex-demo"},[_c('div',{staticClass:"demo-container"},[_c('div',{staticClass:"output-section"},[_c('h3',[_vm._v("解析結果："),_c('button',{on:{"click":_vm.renderLatex}},[_vm._v("解析 LaTeX")])]),_c('div',{ref:"customOutput",domProps:{"innerHTML":_vm._s(_vm.parsedLatex)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }